import './styles.scss';

import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const ComingSoonModal = ({ open, handleClose }: IProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="coming-soon-modal-container">
        <div className="coming-soon-modal-content">
          <div className="header">
            <h1>Coming soon!</h1>
            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>

          <div className="description">
            <p>We are working to make this feature available.</p>
          </div>

          <div className="buttons">
            <Button className="bt ok-button" onClick={handleClose}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ComingSoonModal;
